import React, { ChangeEvent } from 'react'
import { IDocument } from 'types'

interface IFileUploadProps {
  noteId: string
  text?: string
  onUpload?: (files: IDocument[]) => void
  submitNoteApi: (files: File[]) => Promise<any>
}

/** Upload file input */
const FileUpload = ({
  noteId,
  onUpload,
  submitNoteApi,
  text = 'Attach File',
}: IFileUploadProps) => {
  const fileUploadHandler = async ({ target }: ChangeEvent<HTMLInputElement>) => {
    const { files } = target
    if (!files) return

    const fileList: File[] = Array.from(files)
    const noteDocumentsResp = await submitNoteApi(fileList)

    if (onUpload) {
      onUpload(noteDocumentsResp)
    }
  }

  return (
    <label
      className='file-upload btn-fileinput btn-text-link'
      htmlFor={`note-file-upload-${noteId}`}
      data-test='upload-note-files'>
      <input
        type='file'
        id={`note-file-upload-${noteId}`}
        accept='.pdf, .jpg, .jpeg, .png, .doc, .docx, .tiff, .txt'
        onChange={fileUploadHandler}
        data-id={noteId}
        multiple
      />
      {text}
    </label>
  )
}

export default FileUpload
